var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_95_1",
    "data-name": "Componente 95 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_328",
    "data-name": "Rect\\xE1ngulo 328",
    width: 37,
    height: 37,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu_FILL0_wght300_GRAD0_opsz40",
    d: "M140.941-688.527a.907.907,0,0,1-.67-.271.917.917,0,0,1-.27-.673.9.9,0,0,1,.27-.668.916.916,0,0,1,.67-.266h23.55a.907.907,0,0,1,.67.272.916.916,0,0,1,.27.673.9.9,0,0,1-.27.668.915.915,0,0,1-.67.266Zm0-7.489a.907.907,0,0,1-.67-.272.916.916,0,0,1-.27-.673.9.9,0,0,1,.27-.668.916.916,0,0,1,.67-.266h23.55a.906.906,0,0,1,.67.272.916.916,0,0,1,.27.673.9.9,0,0,1-.27.668.916.916,0,0,1-.67.266Zm0-7.489a.907.907,0,0,1-.67-.272.917.917,0,0,1-.27-.673.9.9,0,0,1,.27-.668.916.916,0,0,1,.67-.267h23.55a.907.907,0,0,1,.67.272.917.917,0,0,1,.27.673.9.9,0,0,1-.27.668.916.916,0,0,1-.67.267Z",
    transform: "translate(-134.001 715.384)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.dc907f51fe14d94b6b5eb56285c8340d.svg";
export { ForwardRef as ReactComponent };